import { metaAccount } from '@/router/meta-config'
const permissionKey = 'EVENTCATEGORY'

export default [
  // categories
  {
    path: '/categories',
    name: 'page-categories',
    component: () => import('@/pages/categories'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/category/new',
    name: 'page-category-new',
    component: () => import('@/pages/category'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/category/:id',
    name: 'page-category',
    component: () => import('@/pages/category'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
